/*! WatchTender ブックマーク機能  v1
 *  - 商品ページ／商品カードに「ブックマーク」ボタンを追加
 *  - 商品ページに「現在〇〇人がブックマーク中」を表示
 *  - ヘッダーの♡からブックマーク一覧（ドロワー）を開く
 *  ログイン不要（端末のlocalStorageに保存）。人数のみ集計APIに送信。
 */
(function () {
  'use strict';

  /* ===== 設定 ===== */
  var CFG = {
    // Google Apps Script のウェブアプリURL（.../exec）。空のままでも
    // ブックマーク機能自体は動作し、人数表示だけが非表示になります。
    endpoint: 'https://script.google.com/macros/s/AKfycbw9Itf2BPCWM392RH4VzNiK7GL4vPzssG3IOvOj8Gh5KTHI60RjvbZtd01Pvrr11D-_Yw/exec',
    // この人数未満のときは「現在〇〇人がブックマーク中」を出さない
    minShow: 3,
    ink: '#12302C',
    body: '#1C3735',
    bg: '#F0FBF6',
    gold: '#C4A864'
  };

  var LOCALE = (window.Shopify && Shopify.locale) || 'ja';
  var JA = LOCALE.indexOf('ja') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = JA ? {
    save: 'ブックマークする',
    saved: 'ブックマーク中',
    titleOn: 'ブックマークを外す',
    aria: 'ブックマーク',
    drawer: 'ブックマーク',
    remove: '削除',
    empty: 'まだブックマークはありません。<br>気になる一本を\u2661で保存できます。',
    gone: '現在お取り扱いがありません',
    close: '閉じる',
    list: 'ブックマーク一覧',
    countPre: '現在 ', countPost: ' 人がブックマーク中'
  } : {
    save: 'BOOKMARK',
    saved: 'BOOKMARKED',
    titleOn: 'Remove bookmark',
    aria: 'Bookmark',
    drawer: 'BOOKMARKS',
    remove: 'Remove',
    empty: 'No bookmarks yet.<br>Tap \u2661 to save a piece you like.',
    gone: 'No longer available',
    close: 'Close',
    list: 'Bookmarks',
    countPre: '', countPost: ' people have this bookmarked'
  };
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }

  var LS_ITEMS = 'wt_bm_items_v1';
  var LS_VID = 'wt_bm_vid';
  var counts = {};

  /* ===== 保存領域 ===== */
  function load() {
    try { return JSON.parse(localStorage.getItem(LS_ITEMS)) || {}; } catch (e) { return {}; }
  }
  function save(o) {
    try { localStorage.setItem(LS_ITEMS, JSON.stringify(o)); } catch (e) {}
  }
  function vid() {
    var v = null;
    try { v = localStorage.getItem(LS_VID); } catch (e) {}
    if (!v) {
      v = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem(LS_VID, v); } catch (e) {}
    }
    return v;
  }

  /* ===== API ===== */
  function apiCounts(handles) {
    if (!CFG.endpoint || !handles.length) return;
    var url = CFG.endpoint + '?action=counts&handles=' + encodeURIComponent(handles.join(','));
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.counts) return;
        for (var k in d.counts) counts[k] = d.counts[k];
        paintCounts();
      })
      .catch(function () {});
  }

  function apiToggle(handle, on, title, done) {
    if (!CFG.endpoint) { if (done) done(null); return; }
    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ action: 'toggle', visitor: vid(), handle: handle, on: on, title: title || '' })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && typeof d.count === 'number') { counts[handle] = d.count; paintCounts(); }
        if (done) done(d);
      })
      .catch(function () { if (done) done(null); });
  }

  /* ===== ユーティリティ ===== */
  function handleFromUrl(u) {
    var m = String(u || '').split('?')[0].match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function priceOf(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('.visually-hidden'), function (n) { n.remove(); });
    var m = (c.textContent || '').replace(/\s+/g, ' ').match(/[¥￥][\d,]+/);
    return m ? m[0] : '';
  }

  var HEART =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.6s-7.6-4.7-9.5-9.1C1 7.9 3.1 4.6 6.4 4.6c2 0 3.5 1.1 4.4 2.5l1.2 1.8 1.2-1.8c.9-1.4 2.4-2.5 4.4-2.5 3.3 0 5.4 3.3 3.9 6.9-1.9 4.4-9.5 9.1-9.5 9.1z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

  /* ===== CSS ===== */
  function injectCss() {
    if (document.getElementById('wt-bm-css')) return;
    var css = [
      '.wt-bm-wrap{margin:18px 0 6px;}',
      '.wt-bm-btn{display:inline-flex;align-items:center;justify-content:center;gap:.6em;width:100%;',
      'padding:12px 18px;border:1px solid ' + CFG.ink + ';background:transparent;color:' + CFG.ink + ';',
      'font:inherit;font-size:.92rem;letter-spacing:.18em;border-radius:0;cursor:pointer;',
      'transition:background .2s,color .2s;}',
      '.wt-bm-btn:hover{background:rgba(18,48,44,.06);}',
      '.wt-bm-btn[aria-pressed="true"]{background:' + CFG.ink + ';color:' + CFG.bg + ';}',
      '.wt-bm-btn[aria-pressed="true"] svg path{fill:' + CFG.gold + ';stroke:' + CFG.gold + ';}',
      '.wt-bm-btn svg{flex:none;}',
      '.wt-bm-count{margin:10px 0 0;font-size:.82rem;letter-spacing:.08em;color:' + CFG.body + ';opacity:.85;text-align:center;}',
      '.wt-bm-count strong{color:' + CFG.gold + ';font-weight:600;font-size:1.02rem;padding:0 .15em;}',
      '.wt-bm-count[hidden]{display:none;}',

      /* 商品カード上の♡ */
      '.card-wrapper{position:relative;}',
      '.wt-bm-card{position:absolute;top:10px;right:10px;z-index:6;width:36px;height:36px;display:flex;',
      'align-items:center;justify-content:center;border:none;border-radius:50%;cursor:pointer;',
      'background:rgba(240,251,246,.88);color:' + CFG.ink + ';padding:0;',
      'box-shadow:0 1px 4px rgba(18,48,44,.18);transition:transform .15s;}',
      '.wt-bm-card:hover{transform:scale(1.08);}',
      '.wt-bm-card[aria-pressed="true"] svg path{fill:' + CFG.gold + ';stroke:' + CFG.gold + ';}',

      /* ヘッダー */
      '.wt-bm-open{position:relative;background:none;border:none;cursor:pointer;color:inherit;',
      'display:flex;align-items:center;padding:0 .6rem;}',
      '.wt-bm-open svg{width:20px;height:20px;}',
      '.wt-bm-open .wt-bm-badge{position:absolute!important;top:2px;right:-2px;min-width:16px!important;',
      'height:16px!important;line-height:16px!important;display:block!important;box-sizing:border-box;',
      'border-radius:8px;background:' + CFG.gold + ';color:#fff;font-size:10px;letter-spacing:0;text-align:center;padding:0 3px;}',
      '.wt-bm-open .wt-bm-badge[hidden]{display:none!important;}',

      /* ドロワー */
      '.wt-bm-drawer{position:fixed;inset:0;z-index:100000;}',
      '.wt-bm-drawer[hidden]{display:none;}',
      '.wt-bm-ov{position:absolute;top:0;right:0;bottom:0;left:0;display:block!important;background:rgba(18,48,44,.45);}',
      '.wt-bm-panel{position:absolute;top:0;right:0;height:100%;width:min(420px,92vw);background:' + CFG.bg + ';',
      'color:' + CFG.body + ';display:flex;flex-direction:column;box-shadow:-4px 0 24px rgba(18,48,44,.2);}',
      '.wt-bm-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;',
      'border-bottom:1px solid rgba(18,48,44,.15);}',
      '.wt-bm-head h2{margin:0;font-size:1rem;letter-spacing:.2em;color:' + CFG.ink + ';font-weight:400;}',
      '.wt-bm-close{background:none;border:none;font-size:1.5rem;line-height:1;cursor:pointer;color:' + CFG.ink + ';padding:0 4px;}',
      '.wt-bm-list{flex:1;overflow-y:auto;padding:8px 22px 28px;}',
      '.wt-bm-item{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid rgba(18,48,44,.1);}',
      '.wt-bm-item img,.wt-bm-noimg{width:74px;height:74px;object-fit:cover;flex:none;background:#fff;display:block;}',
      '.wt-bm-item .wt-bm-meta{flex:1;min-width:0;}',
      '.wt-bm-item a{color:' + CFG.ink + ';text-decoration:none;font-size:.88rem;line-height:1.5;display:block;}',
      '.wt-bm-item a:hover{text-decoration:underline;}',
      '.wt-bm-price{font-size:.82rem;opacity:.9;margin:6px 0 0;min-height:1em;}',
      '.wt-bm-gone{color:#8a8f8d;letter-spacing:.08em;font-size:.74rem;}',
      '.wt-bm-del{background:none;border:none;color:' + CFG.body + ';opacity:.55;font-size:.76rem;',
      'cursor:pointer;padding:6px 0 0;letter-spacing:.06em;}',
      '.wt-bm-del:hover{opacity:1;}',
      '.wt-bm-empty{padding:48px 4px;text-align:center;font-size:.86rem;line-height:2;opacity:.8;}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'wt-bm-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ===== 状態反映 ===== */
  function isOn(h) { return !!load()[h]; }

  function paintCounts() {
    var el = document.querySelector('.wt-bm-count');
    if (!el) return;
    var h = el.getAttribute('data-h');
    var n = counts[h];
    if (typeof n === 'number' && n >= CFG.minShow) {
      setText(el.querySelector('strong'), String(n));
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function paintButtons() {
    var items = load();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wt-bm]'), function (b) {
      var on = !!items[b.getAttribute('data-wt-bm')];
      setAttr(b, 'aria-pressed', on ? 'true' : 'false');
      setText(b.querySelector('.wt-bm-label'), on ? T.saved : T.save);
      setAttr(b, 'title', on ? T.titleOn : T.save);
    });
    var badge = document.querySelector('.wt-bm-badge');
    if (badge) {
      var n = Object.keys(items).length;
      setText(badge, String(n));
      badge.hidden = n === 0;
    }
  }

  function toggle(handle, meta) {
    var items = load();
    var on;
    if (items[handle]) { delete items[handle]; on = false; }
    else {
      items[handle] = { t: meta.title || '', u: meta.url || '', i: meta.image || '', at: Date.now() };
      on = true;
      var ks = Object.keys(items);
      if (ks.length > 200) {
        ks.sort(function (a, b) { return (items[a].at || 0) - (items[b].at || 0); });
        for (var i = 0; i < ks.length - 200; i++) delete items[ks[i]];
      }
    }
    save(items);
    paintButtons();
    renderList();
    apiToggle(handle, on, meta.title);
  }

  /* ===== 商品ページ ===== */
  function initProduct() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.wt-bm-wrap')) return;
    var handle = handleFromUrl(location.pathname);
    if (!handle) return;

    var title = txt(info.querySelector('.product__title h1, .product__title h2, .product__title')) ||
                txt(document.querySelector('h1'));
    var price = priceOf(info.querySelector('.price'));
    var imgEl = document.querySelector('.product__media img, .product-media img, .product__media-item img');
    var image = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    var wrap = document.createElement('div');
    wrap.className = 'wt-bm-wrap';
    wrap.innerHTML =
      '<button type="button" class="wt-bm-btn" data-wt-bm="' + esc(handle) + '" aria-pressed="false">' +
      HEART + '<span class="wt-bm-label">' + esc(T.save) + '</span></button>' +
      '<p class="wt-bm-count" data-h="' + esc(handle) + '" hidden>' +
      esc(T.countPre) + '<strong>0</strong>' + esc(T.countPost) + '</p>';

    var anchor = info.querySelector('.product-form__buttons') || info.querySelector('product-form');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    else info.appendChild(wrap);

    wrap.querySelector('.wt-bm-btn').addEventListener('click', function () {
      toggle(handle, { title: title, url: location.pathname, image: image, price: price });
    });

    apiCounts([handle]);
  }

  /* ===== 商品カード ===== */
  function initCards() {
    var cards = document.querySelectorAll('.card-wrapper:not([data-wt-bm-done])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-wt-bm-done', '1');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;

      var img = card.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wt-bm-card';
      b.setAttribute('data-wt-bm', handle);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', T.aria);
      b.innerHTML = HEART;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        toggle(handle, {
          title: txt(card.querySelector('.card__heading, .card-information__text, .card-information a, h3')) || txt(link),
          url: link.getAttribute('href').split('?')[0],
          image: img ? (img.currentSrc || img.src) : '',
          price: priceOf(card.querySelector('.price'))
        });
      });
      card.appendChild(b);
    });
    paintButtons();
  }

  /* ===== ヘッダー・ドロワー ===== */
  function initHeader() {
    if (document.querySelector('.wt-bm-open')) return;
    var right = document.querySelector('.header__right') || document.querySelector('.header__icons');
    if (!right) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'header__icon wt-bm-open';
    btn.setAttribute('aria-label', T.list);
    btn.setAttribute('title', T.list);
    btn.innerHTML = HEART + '<span class="wt-bm-badge" hidden>0</span>';
    var account = right.querySelector('.header__icon--account') || right.querySelector('cart-drawer');
    if (account) right.insertBefore(btn, account); else right.appendChild(btn);
    btn.addEventListener('click', openDrawer);
  }

  function ensureDrawer() {
    var d = document.querySelector('.wt-bm-drawer');
    if (d) return d;
    d = document.createElement('div');
    d.className = 'wt-bm-drawer';
    d.hidden = true;
    d.innerHTML =
      '<div class="wt-bm-ov"></div>' +
      '<aside class="wt-bm-panel" role="dialog" aria-label="' + esc(T.list) + '">' +
      '<div class="wt-bm-head"><h2>' + esc(T.drawer) + '</h2>' +
      '<button type="button" class="wt-bm-close" aria-label="' + esc(T.close) + '">&times;</button></div>' +
      '<div class="wt-bm-list"></div></aside>';
    document.body.appendChild(d);
    d.querySelector('.wt-bm-ov').addEventListener('click', closeDrawer);
    d.querySelector('.wt-bm-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    return d;
  }

  var prodCache = {};
  function fetchProduct(h, cb) {
    if (Object.prototype.hasOwnProperty.call(prodCache, h)) { cb(prodCache[h]); return; }
    fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { prodCache[h] = d; cb(d); })
      .catch(function () { prodCache[h] = null; cb(null); });
  }
  function yen(n) {
    if (typeof n !== 'number') return '';
    return '\u00a5' + Math.round(n / 100).toLocaleString('ja-JP');
  }

  function renderList() {
    var d = document.querySelector('.wt-bm-drawer');
    if (!d) return;
    var box = d.querySelector('.wt-bm-list');
    var items = load();
    var keys = Object.keys(items).sort(function (a, b) { return (items[b].at || 0) - (items[a].at || 0); });
    if (!keys.length) {
      box.innerHTML = '<p class="wt-bm-empty">' + T.empty + '</p>';
      return;
    }
    box.innerHTML = keys.map(function (h) {
      var it = items[h];
      var url = it.u || (ROOT + 'products/' + encodeURIComponent(h));
      var k = esc(h);
      return '<div class="wt-bm-item" data-h="' + k + '">' +
        (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy">' : '<span class="wt-bm-noimg"></span>') +
        '<div class="wt-bm-meta"><a href="' + esc(url) + '">' + esc(it.t || h) + '</a>' +
        '<p class="wt-bm-price"></p>' +
        '<button type="button" class="wt-bm-del" data-del="' + k + '">' + esc(T.remove) + '</button>' +
        '</div></div>';
    }).join('');

    Array.prototype.forEach.call(box.querySelectorAll('.wt-bm-del'), function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-del');
        var o = load(); delete o[h]; save(o);
        paintButtons(); renderList();
        apiToggle(h, false, '');
      });
    });

    // 価格・在庫を最新の商品データで更新
    keys.forEach(function (h) {
      fetchProduct(h, function (pd) {
        var row = box.querySelector('.wt-bm-item[data-h="' + h.replace(/"/g, '\\"') + '"]');
        if (!row) return;
        var pe = row.querySelector('.wt-bm-price');
        if (!pd) { pe.innerHTML = '<span class="wt-bm-gone">' + esc(T.gone) + '</span>'; return; }
        var store = load();
        if (store[h]) {
          store[h].t = pd.title || store[h].t;
          if (pd.featured_image) store[h].i = 'https:' + String(pd.featured_image).replace(/^https?:/, '');
          store[h].u = ROOT + 'products/' + pd.handle;
          save(store);
        }
        var img = row.querySelector('img');
        if (pd.featured_image && !img.getAttribute('src')) img.src = 'https:' + String(pd.featured_image).replace(/^https?:/, '');
        pe.innerHTML = yen(pd.price) + (pd.available ? '' : ' <span class="wt-bm-gone">SOLD OUT</span>');
      });
    });
  }

  function openDrawer() {
    var d = ensureDrawer();
    renderList();
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.querySelector('.wt-bm-drawer');
    if (d) d.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ===== 起動 ===== */
  function boot() {
    injectCss();
    ensureDrawer();
    initHeader();
    initProduct();
    initCards();
    paintButtons();

    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { initCards(); initProduct(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.WTBookmark = { config: CFG, open: openDrawer, items: load };
})();
